export default __webpack_public_path__ + "static/media/p2023-30.89e90907.jpeg";